import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { resolve, reject } from 'q';

import { environment } from "../../environments/environment";
import { encode } from 'punycode';
import { BehaviorSubject } from 'rxjs';
// import { AlertService } from './alert.service';

@Injectable()
export class DashboardService {
    constructor(private http: HttpClient) { };
    private il = new BehaviorSubject<string>('');
    inventory = this.il.asObservable();
    public getDashboard(data) {
        const getDashboardObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/dashboard/admin?companyId=${data}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getDashboardObservable; 
    } // prifle end*/
   
} // class

// Mon Apr 15 2019 13:33:13 GMT-0600